module.exports = __webpack_public_path__ + "img/188.745d6e6c.jpg";